import Hubspot from '../../services/Hubspot';

export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('askForm', () => ({
        inputs: {
          fullname: '',
          email: '',
          message: '',
        },
        errors: {},
        showMessage: false,
        successMessage: true,
        errorMessage: false,

        validateField(fieldName) {
          delete this.errors[fieldName];
          switch (fieldName) {
            case 'fullname':
              if (!this.inputs.fullname.trim()) {
                this.errors.fullname = 'Please complete this required field.';
              } else if (!/^[A-Za-z0-9 ]+$/.test(this.inputs.fullname)) {
                this.errors.fullname =
                  'Must only contain letters, numbers, and spaces.';
              } else if (this.inputs.fullname.length > 50) {
                this.errors.fullname = 'Must be less than 50 characters.';
              }
              break;

            case 'email':
              if (!this.inputs.email.trim()) {
                this.errors.email = 'Please complete this required field.';
              } else if (!this.validateEmail(this.inputs.email)) {
                this.errors.email = 'Email must be formatted correctly.';
              }
              break;

            case 'message':
              if (!this.inputs.message.trim()) {
                this.errors.message = 'Please complete this required field.';
              }
              break;

            default:
              break;
          }
        },

        validateAll() {
          this.errors = {};

          Object.keys(this.inputs).forEach((fieldName) => {
            this.validateField(fieldName);
          });
        },

        validateEmail(email) {
          const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return re.test(email.toLowerCase());
        },

        async submitForm() {
          this.validateAll();
          if (Object.keys(this.errors).length > 0) {
            return;
          }
          const payload = {
            fullname: this.inputs.fullname,
            email: this.inputs.email,
            message: this.inputs.message,
          };

          try {
            const { data } = await Hubspot.submitAskForm(payload);

            if (data?.data || data.includes('Form submitted successfully')) {
              this.showMessage = true;
              this.successMessage =
                data?.data?.inlineMessage || 'Thanks for submitting the form.';
              this.errorMessage = false;
              this.resetForm();
            } else {
              this.showMessage = true;
              this.successMessage = '';
              this.errorMessage = 'Failed to submit form, try again.';
            }
          } catch (error) {
            this.showMessage = true;
            this.successMessage = '';
            this.errorMessage = 'Failed to submit form, try again.';
          }
        },

        resetForm() {
          this.inputs.fullname = '';
          this.inputs.email = '';
          this.inputs.message = '';
          this.errors = {};
          const formWrapper = document.getElementById('form-wrapper');

          if (formWrapper) {
            formWrapper.scrollIntoView({ behavior: 'smooth' });
          }
        },
      }));
    });
  },
};
